import React, { useEffect, useState } from 'react';
import { TextField, Button, Container, Typography, Alert, Box, Modal, TextareaAutosize, ButtonGroup, IconButton, CircularProgress, Select, MenuItem, Menu } from '@mui/material';
import { req, reqPoll } from './ServerUtils';
import ImagesUploader from './ImagesUploader';
import { useParams } from 'react-router-dom';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import QuoteInspirationUploader from './QuoteInspirationUploader';
import { useUser } from './UserProvider';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const QuotesPromptEditor = () => {
  const { userInfo } = useUser();
  const [templates, setTemplates] = useState([]);
  const [deleteMenuOpen, setDeleteMenuOpen] = useState(false);
  const [deleteMenuAnchor, setDeleteMenuAnchor] = useState(null);
  useEffect(() => {
    req('/designer/quote-templates/unapproved').then(res => { // todo: change to /designer/quote-templates
        setTemplates(res.templates);
    })
  }, []);

  if (!userInfo || !userInfo.permissions.includes("designer")) {
    console.log("Not authorized", userInfo);
    return (<div>Loading...</div>);
  }

  const generatePreview = (template) => {
    reqPoll('/designer/quote-templates/generate-preview', 'POST', JSON.stringify({
        template_id: template.id,
        prompt: template.prompt,
        quote_prompt: template.quote_prompt
    })).then(res => {
        console.log(res);
        setTemplates(templates.map(t => t.id === template.id ? {...t, preview: res.preview} : t));
    });
  }
  return (
    <Container maxWidth="lg" sx={{ mt: 5, display: 'flex', gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: "stretch",
            gap: 20,

            border: 'solid 1px #ccc',
            // padding: 20
        }}>
            {templates.map(template => (
                <div key={template.id} style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    gap: 20,
                    padding: 20,
                    borderBottom: "solid 1px #ccc"
                }}>

                    <img src={'https://cdn.makemybrand.ai/' + template.inspiration} alt="Inspiration" style={{width: '300px', height: 'auto', borderRadius: 5}}/>
                    <div key={template.id} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'start',
                        alignItems: "stretch",
                        gap: 20
                    }}>
                        Prompt:
                        <TextareaAutosize 
                            value={template.prompt}
                            onChange={e => {
                                setTemplates(templates.map(t => t.id === template.id ? {...t, prompt: e.target.value} : t));
                            }}
                            style={{width: '300px', height: '100px'}}
                        />
                        <TextareaAutosize 
                            value={template.quote_prompt}
                            onChange={e => {
                                setTemplates(templates.map(t => t.id === template.id ? {...t, quote_prompt: e.target.value} : t));
                            }}
                            style={{width: '300px', height: '100px'}}
                        />

                        <div style={{display: 'flex', flexDirection: 'row', gap: 10}}>
                            <Button variant="outlined" onClick={() => {
                                generatePreview(template);
                            }} style={{flex: 1}}>Generate</Button>

                            {userInfo.permissions.includes("admin") && (
                                <Button variant="outlined" style={
                                    template.approved ? {
                                        color: "#cd8a8a"
                                    } : {
                                    }
                                } onClick={e => {
                                    req('/designer/quote-templates/change-approval', 'PUT', JSON.stringify({
                                        template_id: template.id,
                                        approved: !template.approved
                                    })).then(res => {
                                        setTemplates(templates.map(t => t.id === template.id ? {...t, approved: !template.approved} : t));
                                        console.log(res);
                                    });
                                }}>
                                    {template.approved ? "Unapprove" : "Approve"}
                                </Button>
                            )}

                            {userInfo.permissions.includes("admin") && (
                                <IconButton style={{
                                    color: "#cd8a8a"
                                }} onClick={e => {
                                    setDeleteMenuAnchor(e.currentTarget);
                                    setDeleteMenuOpen(true);
                                }}>
                                    <MoreVertIcon />
                                    <Menu anchorEl={deleteMenuAnchor} open={deleteMenuOpen} onClose={() => setDeleteMenuOpen(false)}>
                                        <MenuItem onClick={() => {
                                            req('/admin/quote-templates/' + template.id, 'DELETE').then(res => {
                                                console.log(res);
                                            });
                                        }}>Delete</MenuItem>
                                    </Menu>
                                </IconButton>
                            )}
                        </div>
                    </div>
                    <img src={template.preview} alt="Generation" style={{width: '300px', height: 'auto', borderRadius: 5}}/>

                    
                </div>
            ))}
        </div>
      </Box>
    </Container>
  );
};

export default QuotesPromptEditor;
